/* TT cart (Oct 2026) - free gift with purchase
   1. Auto-add: once the order qualifies, the Liquid renders the gift card
      ([data-gwp-offer], hidden by CSS). This file sees it and adds the gift. No click needed.
      The gift is added with the hidden line property _gwp, which is what marks it as the gift.
      A Gem Wrap the customer adds themselves has no _gwp and is a normal paid item.
   2. If the customer removes the gift themselves while still over the threshold, we don't
      force it back in; the gift card shows instead so they can re-add it with one tap.
      That "no" only lasts until the cart drops under the threshold (or empties). The next
      time they cross it, the gift is added automatically again.
   3. Auto-remove: if the order drops under the threshold, the Liquid marks the gift line
      [data-gwp-ineligible] and this file takes it out, so nobody pays for it at checkout.
      Only the _gwp gift line is ever removed. */
(function () {
  if (window.__ttCartBound) return;
  window.__ttCartBound = true;

  var KEY = 'ttGwpDeclined';
  var html = document.documentElement;
  var busy = false;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function declined() {
    try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; }
  }
  function setDeclined(v) {
    try { v ? sessionStorage.setItem(KEY, '1') : sessionStorage.removeItem(KEY); } catch (e) {}
    html.classList.toggle('gwp-declined', !!v);
  }
  html.classList.toggle('gwp-declined', declined());

  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refresh() {
    if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
    document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
  }

  function run(promise) {
    busy = true;
    promise
      .then(refresh)
      .catch(function () {})
      .then(function () { setTimeout(function () { busy = false; }, 1500); });
  }

  function check() {
    if (busy) return;

    var bad = document.querySelector('[data-gwp-ineligible]');
    if (bad) {
      var key = bad.getAttribute('data-gwp-ineligible');
      if (key) run(post('cart/change.js', { id: key, quantity: 0 }));
      return;
    }

    var offer = document.querySelector('[data-gwp-offer]');
    var giftLine = document.querySelector('.tt-line--gift');

    /* Under the threshold (no card, no gift in the bag): forget any earlier "no" */
    if (!offer && !giftLine && declined()) setDeclined(false);

    if (offer && !declined()) {
      var input = offer.querySelector('input[name="id"]');
      var id = input && parseInt(input.value, 10);
      if (id) run(post('cart/add.js', { items: [{ id: id, quantity: 1, properties: { _gwp: '1' } }] }));
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('.tt-line--gift [data-item-remove]')) setDeclined(true);
    if (t.closest('[data-gwp-offer] [data-add-to-cart]')) setDeclined(false);
  }, true);

  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(check, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
})();
